export class GetTotalInput {
    Id: number;
    UserDateOfBirth!: Date;
    UserId!: string;
    Version!: string;
    Questions: GetTotalInput_Question[] = [];
    TestMode?: boolean = false;
    Name: string;
    bgColor?: string;
    txtColor?: string;
}

export class GetTotalInput_Question {
    Code!: string;
    Answers: GetTotalInput_Answer[] = [];

    constructor(_code: string) {
        this.Code = _code;
        this.Answers = [];
    }
}

export class GetTotalInput_Answer {
    Code!: string;
    Value1?: string;
    Value2?: string;
    IsModified: boolean = false;

    constructor(_code: string, _value1: string | null = null, _value2: string | null = null) {
        this.Code = _code;

        this.Value1 = _value1;
        this.Value2 = _value2;
    }
}



export interface GetTotalsResponse {
    Version: string;
    Questions: GetTotalsResponse_Question[];
    Societies: Response_Item[];
    UserId: string;
}

export interface GetTotalsResponse_Question {
    Code: string;
    Answers: Response_Item[];
}

export interface Response_Item {
    Code: string;
    Quantity: number;
    FidaCodes?: string[],
    Selected: boolean,
    MinValue: number,
    MaxValue: number
}

export class Total {
    id: string;
    quantity: number;
    fidaCodes?: string[];
    minValue: number;
    maxValue: number;

    static mapData(responseItem: Response_Item): Total {
        let _total: Total = new Total();
        _total.id = responseItem.Code;
        _total.quantity = responseItem.Quantity;
        _total.fidaCodes = responseItem.FidaCodes;
        _total.minValue = responseItem.MinValue;
        _total.maxValue = responseItem.MaxValue;

        return _total
    }
}

export type Totals = Total[];